import $ from "jquery";

$(document).on('turbo:load', function () {
    $('a[href$=".pdf"]').prop('target', '_blank');
});